export const GET_DATA_ROWS_AJUSTE_RETROACTIVO =
  'casos/GET_DATA_ROWS_AJUSTE_RETROACTIVO';
export const FETCH_DATA_AJUSTE_RETROACTIVO =
  'casos/FETCH_DATA_AJUSTE_RETROACTIVO';
export const SET_DATA_ROWS_AJUSTE_RETROACTIVO =
  'casos/SET_DATA_ROWS_AJUSTE_RETROACTIVO';
